export default {
  mounted() {
    this.trigger = this.el.querySelector('[data-model-trigger]')
    this.menu = this.el.querySelector('[role=menu]')
    this.items = () => [...this.menu.querySelectorAll('[role=menuitemradio]:not(:disabled)')]
    this.isOpen = () => this.menu.matches(':popover-open')
    this.close = (focus = true) => {
      this.menu.hidePopover()
      if (focus) this.trigger.focus()
    }
    this.position = () => {
      const r = this.trigger.getBoundingClientRect()
      this.menu.style.left = `${Math.max(12, Math.min(r.right - this.menu.offsetWidth, innerWidth - this.menu.offsetWidth - 12))}px`
      this.menu.style.top = `${Math.max(12, Math.min(r.bottom + 6, innerHeight - this.menu.offsetHeight - 12))}px`
    }
    this.open = () => {
      if (this.trigger.disabled) return
      this.menu.showPopover()
      this.position()
      const items = this.items()
      ;(items.find(item => item.getAttribute('aria-checked') === 'true') || items[0])?.focus()
    }
    this.click = event => {
      if (event.target.closest('[data-model-trigger]')) {
        this.isOpen() ? this.close() : this.open()
      } else if (event.target.closest('[role=menuitemradio]:not(:disabled)')) this.close()
    }
    this.key = event => {
      if (event.target === this.trigger && ['ArrowDown', 'ArrowUp'].includes(event.key)) {
        event.preventDefault()
        this.open()
        return
      }
      if (!this.isOpen()) return
      const items = this.items(), index = items.indexOf(document.activeElement)
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 :
        event.key === 'ArrowDown' ? (index + 1) % items.length :
          event.key === 'ArrowUp' ? (index - 1 + items.length) % items.length : null
      if (next !== null) { event.preventDefault(); items[next]?.focus() }
      if (event.key === 'Escape') { event.preventDefault(); this.close() }
      if (event.key === 'Tab') this.close(false)
    }
    this.toggle = () => this.trigger.setAttribute('aria-expanded', String(this.isOpen()))
    this.reposition = () => { if (this.isOpen()) this.position() }
    this.el.addEventListener('click', this.click)
    this.el.addEventListener('keydown', this.key)
    this.menu.addEventListener('toggle', this.toggle)
    window.addEventListener('resize', this.reposition)
    window.addEventListener('scroll', this.reposition, true)
  },
  updated() {
    if (this.trigger.disabled && this.isOpen()) this.close(false)
    this.toggle()
    this.reposition()
  },
  destroyed() {
    this.el.removeEventListener('click', this.click)
    this.el.removeEventListener('keydown', this.key)
    this.menu.removeEventListener('toggle', this.toggle)
    window.removeEventListener('resize', this.reposition)
    window.removeEventListener('scroll', this.reposition, true)
  }
}
